import { render, staticRenderFns } from "./courseCenter.vue?vue&type=template&id=b53f0a1e&scoped=true"
import script from "./courseCenter.vue?vue&type=script&lang=js"
export * from "./courseCenter.vue?vue&type=script&lang=js"
import style0 from "./courseCenter.vue?vue&type=style&index=0&id=b53f0a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53f0a1e",
  null
  
)

export default component.exports